import { render, staticRenderFns } from "./closedPeriodAppraisal.vue?vue&type=template&id=0ffd44a9"
import script from "./closedPeriodAppraisal.vue?vue&type=script&lang=js"
export * from "./closedPeriodAppraisal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports